<app-header></app-header>

<div class="student-shell content as-body pt-16">
  <p>student-shell works!</p>
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>
